<div class="main-container">
  <div class="oportunidades-content">

    <div class="encabezado-consulta">
      <span class="titulo-consulta">
        Ingrese la información de la oportunidad comercial a consultar
      </span>

      <span class="subtitulo-consulta">
        Recuerde que puede hacer la búsqueda general o por cualquier tipo de
        filtro.
      </span>
    </div>

    <form [formGroup]="frmOportunidadesComerciales" class="formOportunidades">
      <div class="form-container row">
        <!-- Campos -->
        <div class="col-12 col-lg-9">
          <div class="row">
            <!-- Tipo de identificación -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Tipo de identificación</mat-label>
    
                <mat-select formControlName="tipo">
                  <mat-option *ngFor="let docItem of documentTypeData" [value]="docItem.acronym">
                    {{ docItem.acronym }} - {{ docItem.name }}
                  </mat-option>
                </mat-select>
    
                <mat-error *ngIf="hasError(getControl['tipo'])">
                  {{
                  printError(getControl["tipo"], {
                  required: "Ingrese el tipo de identificación"
                  })
                  }}
                </mat-error>
              </mat-form-field>
            </div>
    
            <!-- Número de identificación -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Número de identificación</mat-label>
    
                <input matInput type="text" formControlName="numero" maxlength="15" />
    
                <mat-error *ngIf="hasError(getControl['numero'])">
                  {{
                  printError(getControl["numero"], {
                  required: "Ingrese el número de identificación"
                  })
                  }}
                </mat-error>
              </mat-form-field>
            </div>
    
            <!-- Estado de la oportunidad -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Estado oportunidad comercial</mat-label>
    
                <mat-select formControlName="estado">
                  <mat-option *ngFor="let estado of estadoData" [value]="estado.value">
                    {{ estado.label }}
                  </mat-option>
                </mat-select>
    
                <mat-error *ngIf="hasError(getControl['estado'])">
                  {{
                  printError(getControl["estado"], {
                  required: "Ingrese el estado de oportunidad comercial"
                  })
                  }}
                </mat-error>
              </mat-form-field>
            </div>
    
            <!-- Fecha creación -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
                <mat-label>Fecha creación oportunidad comercial</mat-label>
    
                <input matInput formControlName="fecha_inicio" [matDatepicker]="pickerInicio" placeholder="YYYY/MM/DD" />
    
                <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
    
                <mat-datepicker #pickerInicio></mat-datepicker>
              </mat-form-field>
            </div>
    
            <!-- Fecha última gestión -->
            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field appearance="outline" floatLabel="always" style="width: 100%">
                <mat-label>Fecha última gestión</mat-label>
    
                <input matInput formControlName="fecha_ultima" [matDatepicker]="pickerUltima" placeholder="YYYY/MM/DD" />
    
                <mat-datepicker-toggle matSuffix [for]="pickerUltima"></mat-datepicker-toggle>
    
                <mat-datepicker #pickerUltima></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
    
        <!-- Botones -->
        <div class="col-12 col-lg-3 botones-columna">
          <div class="botones-container">
            <button type="submit" class="btn btn-primary btn-icon" (click)="consultarOportunidades()" appTrackClick
              [trackData]="{
                module: 'Mis oportunidades comerciales',
                category: 'N/A',
                submodule: 'Consulta mis oportunidades comerciales',
                functionality: 'Consultar',
                identificadorInteraccion:
                  'OPO_COM_CONSULTA_OPO_COM_CONSULTAR'
              }">
              <mat-icon>search</mat-icon>
              <span>CONSULTAR</span>
            </button>
    
            <button type="button" class="btn btn-primary btn-icon" (click)="limpiarFormulario()">
              <mat-icon>cancel</mat-icon>
              <span>LIMPIAR</span>
            </button>
          </div>
        </div>
      </div>
    </form>

    <!-- Tabla de resultados -->
    <div *ngIf="userData && userData.length > 0" class="mt-4 table-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        matSortActive="fechaCreacion"
        matSortDirection="desc"
        matSortDisableClear
        class="mat-elevation-z8 full-width-table"
      >
        <!-- Fecha de creación -->
        <ng-container matColumnDef="fechaCreacion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Fecha creación oportunidad comercial
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.fechaCreacion | date : "yyyy-MM-dd" }}
          </td>
        </ng-container>

        <!-- Tipo identificación -->
        <ng-container matColumnDef="tipoIdentificacion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Tipo de identificación usuario
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.tipoIdentificacion }}
          </td>
        </ng-container>

        <!-- Número identificación -->
        <ng-container matColumnDef="numeroIdentificacion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Número de identificación usuario
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.numeroIdentificacion }}
          </td>
        </ng-container>

        <!-- Nombre completo -->
        <ng-container matColumnDef="nombreApellido">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Nombre y apellido usuario
          </th>
          <td mat-cell *matCellDef="let element">{{ element.nombreApellido }}</td>
        </ng-container>

        <!-- Campaña -->
        <ng-container matColumnDef="campania">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Campaña
          </th>
          <td mat-cell *matCellDef="let element">{{ element.campania }}</td>
        </ng-container>

        <!-- Linea de negocio -->
        <ng-container matColumnDef="lineaNegocio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Línea de negocio
          </th>
          <td mat-cell *matCellDef="let element">{{ element.lineaNegocio }}</td>
        </ng-container>

        <!-- Observaciones -->
        <ng-container matColumnDef="observaciones">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Observaciones
          </th>
          <td mat-cell *matCellDef="let element">{{ element.observacion }}</td>
        </ng-container>

        <!-- Celular -->
        <ng-container matColumnDef="celular">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Celular
          </th>
          <td mat-cell *matCellDef="let element">{{ element.celular }}</td>
        </ng-container>

        <!-- Correo -->
        <ng-container matColumnDef="correo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Correo electrónico
          </th>
          <td mat-cell *matCellDef="let element">{{ element.correo }}</td>
        </ng-container>

        <!-- Estado -->
        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Estado oportunidad comercial
          </th>
          <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
        </ng-container>

        <!-- Fecha última gestión -->
        <ng-container matColumnDef="fechaUltimaGestion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Fecha última gestión
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.fechaUltimaGestion | date : "yyyy-MM-dd" }}
          </td>
        </ng-container>

        <!-- Cumplimiento (Semáforo) -->
        <ng-container matColumnDef="cumplimiento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Cumplimiento tiempos de gestión
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="circle" [ngClass]="element.colorSemaforo"></div>
          </td>
        </ng-container>
        <!-- Acciones -->
        <ng-container matColumnDef="acciones">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Acciones
          </th>
          <td mat-cell *matCellDef="let element">
            <div style="display: flex; gap: 8px; align-items: center">
              <button mat-icon-button matTooltip="Cambiar estado" (click)="abrirCambiarEstado(element)" appTrackClick
                [trackData]="{
                module: 'Mis oportunidades comerciales',
                category: 'N/A',
                submodule: 'Consulta mis oportunidades comerciales',
                functionality: 'Cambiar estado',
                identificadorInteraccion: 'OPO_COM_CONSULTA_OPO_COM_CAMBIAR_ESTADO'
              }" style="
                border-radius: 10%;
                width: 32px;
                height: 32px;
                padding: 0;
                background-color: #ffcc00;
                min-width: 0;
                display: flex;
                align-items: center;
                justify-content: center;
              ">
                <img src="assets/imagenes/flecha-derecha.png" alt="Cambiar estado"
                  style="width: 16px; height: 16px; border-radius: 50%" />
              </button>

              <!-- <button (click)="consultarResumenPorEstado()">Ver resumen</button> -->

              <button mat-icon-button class="botonBitacora" (click)="abrirBitacora(element)" appTrackClick [trackData]="{
                module: 'Mis oportunidades comerciales',
                category: 'N/A',
                submodule: 'Consulta mis oportunidades comerciales',
                functionality: 'Información bitácora',
                identificadorInteraccion: 'OPO_COM_CONSULTA_OPO_COM_BITACORA'
              }" matTooltip="Información bitácora" (mouseenter)="hoveringBitacora = true"
                (mouseleave)="hoveringBitacora = false">
                <img [src]="
                  hoveringBitacora
                    ? 'assets/imagenes/bitacora-alreves.png'
                    : 'assets/imagenes/bitacora.png'
                " alt="Bitácora" style="width: 16px; height: 16px" />
              </button>
            </div>
          </td>
        </ng-container>

        <!-- Filas -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10]"
        [showFirstLastButtons]="true"
        aria-label="Paginación de oportunidades comerciales"
      >
      </mat-paginator>

      <!-- Bitácora visual -->
      <ng-template #bitacoraDialog>
        <div style="
          background-color: white;
          border-radius: 10px;
          padding: 24px;
          max-width: 800px;
          margin: auto;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        ">
          <button mat-icon-button (click)="dialog.closeAll()" aria-label="Cerrar"
            style="position: absolute; top: 12px; right: 12px; color: #a2a5bc">
            <mat-icon>close</mat-icon>
          </button>
          <h2 style="text-align: center; margin-bottom: 16px">
            Bitácora de la oportunidad
          </h2>

          <table style="width: 100%; border-collapse: collapse; font-size: 14px">
            <thead style="background-color: #f2f2f2">
              <tr>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd">
                  Fecha modificación
                </th>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd">
                  Estado actual
                </th>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd">
                  Observaciones
                </th>
                <th style="padding: 8px; text-align: left; border: 1px solid #ddd">
                  Nombre usuario asesor
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of bitacoraSeleccionada">
                <td style="padding: 8px; border: 1px solid #ddd">
                  {{ item.fecha | date : "yyyy-MM-dd HH:mm:ss" }}
                </td>
                <td style="padding: 8px; border: 1px solid #ddd">
                  {{ item.estado }}
                </td>
                <td style="padding: 8px; border: 1px solid #ddd">
                  {{ item.observaciones }}
                </td>
                <td style="padding: 8px; border: 1px solid #ddd">
                  {{ item.usuario }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>

      <!-- Aquí agregamos el template del diálogo -->
      <ng-template #cambioEstadoDialog>
        <div style="
          position: relative;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
          padding-top: 16px;
        ">
          <!-- Botón cerrar SIEMPRE visible -->
          <button mat-icon-button (click)="cerrarDialogoEstado()" aria-label="Cerrar" style="
            position: absolute;
            top: 12px;
            right: 12px;
            color: #a2a5bc;
            z-index: 1000;
            pointer-events: auto;
          ">
            <mat-icon>close</mat-icon>
          </button>

          <!-- Este título solo si no se ha finalizado -->
          <h2 *ngIf="!estadoCambioExitoso" mat-dialog-title style="text-align: center; margin: 0; margin-bottom: 16px">
            Cambio de estado
          </h2>

          <mat-dialog-content style="padding: 24px; padding-bottom: 0">
            <!-- Mensaje de éxito -->
            <div *ngIf="estadoCambioExitoso" style="
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-top: 24px;
            ">
              <div style="
                height: 70px;
                width: 70px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 16px;
              ">
                <img src="assets/imagenes/listo.png" style="height: 80px" alt="icono éxito" />
              </div>

              <h2 style="margin-bottom: 10px; font-weight: bold">Información</h2>
              <p style="font-weight: 500">{{ mensajeExitoCambio }}</p>
            </div>

            <!-- Paso 1: selección de estado -->
            <ng-container *ngIf="!mostrarObservacion && !estadoCambioExitoso">
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Cambiar estado a:</mat-label>
                <mat-select [(ngModel)]="estadoTemporalSeleccionado">
                  <mat-option *ngFor="let estado of opcionesCambioEstado" [value]="estado">
                    {{ estado.toUpperCase() }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>

            <!-- Paso 2: observaciones -->
            <ng-container *ngIf="mostrarObservacion && !estadoCambioExitoso" style="background-color: white !important">
              <div style="width: 100%">
                <label for="observaciones" style="display: block; margin-bottom: 6px">Observaciones</label>
                <textarea id="observaciones" style="
                  width: 100%;
                  height: 5vh;
                  padding: 8px;
                  border: 1px solid #ccc;
                  border-radius: 4px;
                  resize: vertical;
                  outline: none;
                " [(ngModel)]="observacionesEstado" maxlength="150"></textarea>
                <div style="
                  text-align: right;
                  font-size: 0.85rem;
                  color: #666;
                  margin-top: 4px;
                ">
                  {{ observacionesEstado.length }}/150
                </div>
              </div>
            </ng-container>
          </mat-dialog-content>

          <mat-dialog-actions align="center">
            <!-- Paso 1: botón continuar -->
            <ng-container *ngIf="!mostrarObservacion && !estadoCambioExitoso">
              <button mat-button color="primary" style="color: white; background-color: #478aee"
                (click)="continuarCambioEstado()">
                Continuar
              </button>
            </ng-container>

            <!-- Paso 2: botón finalizar -->
            <ng-container *ngIf="mostrarObservacion && !estadoCambioExitoso">
              <button mat-raised-button color="primary" (click)="finalizarCambioEstado()">
                Finalizar
              </button>
            </ng-container>

            <!-- Éxito: botón OK -->
            <ng-container *ngIf="estadoCambioExitoso">
              <button mat-raised-button color="primary" (click)="cerrarDialogoEstado()">
                OK
              </button>
            </ng-container>
          </mat-dialog-actions>
        </div>
      </ng-template>
    </div>
  </div>
